import { render, staticRenderFns } from "./OfflineBooksPurchase.vue?vue&type=template&id=75e14135"
import script from "./OfflineBooksPurchase.vue?vue&type=script&lang=ts"
export * from "./OfflineBooksPurchase.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports